import React, { MouseEvent } from 'react';
import StyledRuleBuilderActionMenu from './StyledRuleBuilderActionMenu';
import * as GStyled from '../../../../styles/components';
import { Icon } from '../../../../components';

interface RuleBuilderActionMenuProps {
  onAddRuleClick?: (e: MouseEvent) => void;
  onDeleteClick?: (e: MouseEvent) => void;
}

function RuleBuilderActionMenu({
  onAddRuleClick,
  onDeleteClick,
}: RuleBuilderActionMenuProps): JSX.Element {
  return (
    <StyledRuleBuilderActionMenu>
      <GStyled.LinkButton onClick={onAddRuleClick}>
        <GStyled.Text fontWeight="medium" size="md" color="lqBlue">
          +Add Rule
        </GStyled.Text>
      </GStyled.LinkButton>
      <GStyled.FlatButton onClick={onDeleteClick}>
        <Icon name="trash" />
      </GStyled.FlatButton>
    </StyledRuleBuilderActionMenu>
  );
}

export default RuleBuilderActionMenu;
